import { cva, type VariantProps } from 'class-variance-authority'
import { Spinner, type SpinnerProps } from '../../Spinner/Spinner'
import { cn } from '../../utils/cn' //! Has to be relative import to avoid widget build issues (build:widgets)
import { type ButtonVariant } from './SolidButton'

const buttonSpinnerBackgroundVariants = cva('', {
  variants: {
    variant: {
      primary:
        'bg-primary-500 group-hover:bg-primary-600 group-active:bg-primary-800',
      secondary: 'group-active:bg-primary-600 bg-white',
      tertiary:
        'bg-[#FFD900] group-hover:bg-[#FFBF00] group-active:bg-[#D2850B]',
      textlink: 'bg-white',
      destructive:
        'bg-error-600 group-hover:bg-error-700 group-active:bg-error-800',
    } satisfies Record<ButtonVariant, string>,
  },
})

export interface SolidButtonSpinnerProps
  extends VariantProps<typeof buttonSpinnerBackgroundVariants> {
  size?: SpinnerProps['size']
  className?: string
}

export const SolidButtonSpinner = ({
  variant,
  size = 'xsmall',
  className,
}: SolidButtonSpinnerProps) => {
  return (
    <Spinner
      backgroundClasses={buttonSpinnerBackgroundVariants({ variant })}
      className={cn('text-text-800', className)}
      size={size}
    />
  )
}
